import { Turnstile, type TurnstileProps } from "@marsidev/react-turnstile"
import { useContext } from "react"

import { CaptchaContext } from "./captcha-provider"

export function CaptchaTokenSetter(props: {
  siteKey: string | undefined
  options?: TurnstileProps
}) {
  const { enabled, setToken, setInstance } = useContext(CaptchaContext)

  if (!enabled || !props.siteKey) {
    return null
  }

  const options = props.options ?? {
    options: {
      size: "invisible",
    },
  }

  return (
    <Turnstile
      ref={(instance) => {
        if (instance) {
          setInstance(instance)
        }
      }}
      siteKey={props.siteKey}
      onSuccess={setToken}
      {...options}
    />
  )
}
